import React from 'react';
import { connect } from "react-redux";
import AccessType from "./AccessType";
import ProxyInfo from "./ProxyInfo";
import ProxyAccess from "./ProxyAccess";
import AcceptTerms from "./AcceptTerms";
import MajorUploadDocuments from "./MajorUploadDocuments";
import ProxyConfirmation from "../ProxyConfirmation";
import OurStepManager from "../../common/OurStepManager";
import * as types from "../../../constants/actionTypes";
import ConfirmationModal from "../../common/ConfirmationModal";
import { getAge } from "../../../helpers/dateTime";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import * as queryString from 'query-string';
import { RX, EPIC, REQUEST, RXEPIC, REQUESTV2 } from "../../../constants/textConstants";
import * as ProxyHelper from "../ProxyHelper";

//MAGIC STRINGS
const UNABLETOPROCESSMSG = "The request didn't go through.";
const REQUESTPENDINGMSG = "An access request is already pending a response.";

class ProxyRequest extends React.Component {
    constructor(props) {
        super(props);
        const { dateOfBirth, getProxyRelationshipTypes, useTermsV2Endpoint, listOfSelectedProxyUsers, useOnboardingLayout, removeBSWPharmacy } = this.props;
        if (getProxyRelationshipTypes) {
            getProxyRelationshipTypes();
        }
        const searchParams = props.location && props.location.searchParams ? queryString.parse(props.location.searchParams) : null;
        if (searchParams && searchParams.fromNoProxy)
            this.fromEvisit = JSON.parse(searchParams.fromNoProxy);
        else
            this.fromEvisit = false;
        if (searchParams && searchParams.isPharmacySelectedDefault)
            this.isPharmacySelectedDefault = JSON.parse(searchParams.isPharmacySelectedDefault);
        else
            this.isPharmacySelectedDefault = false;
        if (searchParams && searchParams.isHrSelectedDefault)
            this.isHrSelectedDefault = JSON.parse(searchParams.isHrSelectedDefault);
        else
            this.isHrSelectedDefault = false;
        if (searchParams && searchParams.isDcjEnrollment) {
            this.isDcjEnrollment = JSON.parse(searchParams.isDcjEnrollment);
        } else {
            this.isDcjEnrollment = false;
        }

        this.isFromInHome = !false;
        if (searchParams?.isFromInHome) { this.isFromInHome = JSON.parse(searchParams.isFromInHome) }
        let prefillData = this.props.history?.location?.state?.prefillDetails[0]?.proxyRequest?.receiver
        let prefillDataCondition = useOnboardingLayout && listOfSelectedProxyUsers?.length > 0

        this.state = {
            validDob: false,
            proxyRequest: {
                firstName: prefillDataCondition ? prefillData.firstName == null ? "" : prefillData.firstName : "",
                lastName: prefillDataCondition ? prefillData.lastName == null ? "" : prefillData.lastName : "",
                dob: dateOfBirth ? dateOfBirth : "",
                zipCode: "",
                rxNumber: "",
                phone: "",
                relationship: "",
                email: "",
                mailingAddress: { streetNumber: '', street: '', street2: '', city: '', state: '', zip: '' },
                middleName: "",
                gender: "",
                documentSubmitted: false,
                manageOwnHealthcare: true,
                //isProxyAccessMapped: false
            },
            pharmacy: !removeBSWPharmacy && this.isPharmacySelectedDefault ? true : false,
            healthrecord: removeBSWPharmacy || useOnboardingLayout ? true : props.myChartId ? (this.fromEvisit && (dateOfBirth ? getAge(dateOfBirth) < 18 : true)) || this.isHrSelectedDefault : false,
            isMinor: dateOfBirth ? getAge(dateOfBirth) < 18 : true,
            isSubmitted: false,
            isDcjEnrollment: this.isDcjEnrollment
        };
        this.submitProxyRequest = this.submitProxyRequest.bind(this);
        this.onChange = this.onChange.bind(this);
        this.stepsStatus = [];
        this.baseURL = window.location.pathname;
        this.stepManagerRef = React.createRef();
        this.retryProxyRequest = this.retryProxyRequest.bind(this);
        this.requestAnotherAccess = this.requestAnotherAccess.bind(this);
        this.callbackOnLeave = this.callbackOnLeave.bind(this);
        this.navigateToProxyManagment = this.navigateToProxyManagment.bind(this);
        this.navigateToManageNotifications = this.navigateToManageNotifications.bind(this);
        this.navigateToProxyRequestDOB = this.navigateToProxyRequestDOB.bind(this);
        this.handleSuccessContinue = this.handleSuccessContinue.bind(this);
    }

    componentDidMount() {
        this.mounted = true;
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyRequest.ComponentDidMount${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        const { dateOfBirth, history } = this.props;
        if (!dateOfBirth && history) {
            history.push({ pathname: '/proxyrequestDOB', searchParams: 'fromNoProxy=false' });
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    blockNavigation(nextLocation) {
        return nextLocation && (nextLocation.pathname === "/proxyrequestDOB" || nextLocation.pathname === "/proxyrequest");
    }

    callbackOnLeave = (pathname) => {
        if (window.userToSwitch) {
            this.props.history.push("/proxymanagement");
        }
    }

    dataEntered() {
        if (this.mounted) {
            const { currentStep, healthrecord, pharmacy, proxyRequest } = this.state;
            const { firstName, middleName, lastName, mailingAddress, relationship, phone, email, rxNumber, zipCode, gender, dob, documentSubmitted } = proxyRequest;
            const entered = currentStep > 0 || healthrecord || pharmacy || (firstName && firstName.trim() !== '')
                || (middleName && middleName.trim() !== '')
                || (lastName && lastName.trim() !== '')
                || (relationship && relationship.trim() !== '')
                || (phone && phone.trim() !== '')
                || (rxNumber && rxNumber.trim() !== '')
                || (zipCode && zipCode.trim() !== '')
                || (gender && gender.trim() !== '')
                || (dob && dob.trim() !== '')
                || (email && email.trim() !== '')
                || (mailingAddress && mailingAddress.zip && mailingAddress.zip.trim() !== '')
                || (mailingAddress && mailingAddress.city && mailingAddress.city.trim() !== '')
                || (mailingAddress && mailingAddress.state && mailingAddress.state.trim() !== '')
                || (mailingAddress && mailingAddress.street && mailingAddress.street.trim() !== '')
                || (mailingAddress && mailingAddress.street2 && mailingAddress.street2.trim() !== '')
                || (mailingAddress && mailingAddress.streetNumber && mailingAddress.streetNumber.trim() !== '')
                || documentSubmitted;

            return entered;
        } else {
            return false;
        }
    }

    requestAnotherAccess() {
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyRequest.InitializeRequestData${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        this.props.initializeRequestData();
    }

    handleSuccessContinue() {
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyRequest.OnContinue.Success${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
    }

    getRelationshipCode = (relationship) => {
        const { isMinor } = this.state;
        const { minorRelationships, majorRelationships } = this.props;
        const relationships = isMinor ? minorRelationships : majorRelationships;
        const index = relationships.findIndex(item => item.label === relationship);
        if (index >= 0)
            return relationships[index]["RelationshipCode"];
        else
            return "";
    }

    submitProxyRequest(proxyPharmacyRequest) {
        let { pharmacy, healthrecord, proxyRequest, isMinor } = this.state;
        const { enableProxyRequestV2, useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        const proxySource = ProxyHelper.getProxySource(healthrecord, pharmacy);
        const logProxySource = ProxyHelper.getLogProxySource(proxySource);
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyRequest.${logProxySource}.${isMinor ? "Minor" : "Adult"}.Request${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());

        if (proxyPharmacyRequest) proxyRequest = proxyPharmacyRequest;

        const { city, state, street, streetNumber, street2, zip } = proxyRequest.mailingAddress;
        let requester = {
            myChartId: this.props.myChartId,
            userName: this.props.userDetails.userName
        };
        let receiver = {
            city: city,
            dateOfBirth: proxyRequest.dob,
            email: proxyRequest.email,
            firstName: proxyRequest.firstName,
            gender: proxyRequest.gender,
            lastName: proxyRequest.lastName,
            middleName: healthrecord && proxyRequest.middleName,
            phoneNumber: proxyRequest.phone,
            relationshipCode: this.getRelationshipCode(proxyRequest.relationship),
            state: state,
            streetAddress: street2 ? `${streetNumber} ${street} ${street2}` : `${streetNumber} ${street}`,
            zipCode: zip ? zip : "",
            externalId: pharmacy && proxyRequest.rxNumber
        };

        this.acceptProxyTermsAndConditions();
        logUI(`MBHWeb.UI.ProxyRequest.${logProxySource}.SubmitProxyRequest${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());

        if (healthrecord) {//only Epic
            this.props.requestEpicAccess(
                proxyRequest.attachments || [],
                EPIC,
                receiver,
                requester,
                isMinor ? REQUEST : enableProxyRequestV2 && proxyRequest.manageOwnHealthcare ? REQUESTV2 : REQUEST
            );
        }
        if (pharmacy) { //only Rx
            this.props.requestRxAccess(
                [],
                RX,
                receiver,
                requester,
                REQUEST //not applied request.v2 for pharmacy.
            );
        }

        this.setState({ isSubmitted: true });
    }

    onChange(e) {
        if (this.mounted) {
            this.setState({ [e.target.name]: e.target.checked });
        }
    }

    retryProxyRequest(selectedOption) {
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyRequest.RetryProxyRequest${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        if (selectedOption === 'pharmacy')
            this.setState({ isShowManualAddress: false, isSubmitted: false, isRetry: true, pharmacy: true, healthrecord: false, startAtStep: 0 });
        else if (selectedOption === 'healthrecord')
            this.setState({ isSubmitted: false, isRetry: true, pharmacy: false, healthrecord: true, startAtStep: 0 });
        else
            this.setState({ isSubmitted: false, isRetry: true, pharmacy: true, healthrecord: true, startAtStep: 0 });
    }

    onEdit = (activeInput) => {
        if (activeInput) {
            this.activeInput = document.querySelector('#' + activeInput);
        }
    }

    onStepChange = (success, step) => {
        if (typeof window !== 'undefined' && success) {
            window.scrollTo(0, 0);
        }
        if (success) {
            this.setState({ currentStep: step });
        }
        if (this.activeInput) {
            this.activeInput.focus();
            this.activeInput = null;
        }
    }

    handleManualAddressState = (state) => {
        this.setState({ isShowManualAddress: state });
    }

    onAccessTypeChange = (e) => {
        let { proxyRequest } = this.state;
        const { useOnboardingLayout } = this.props;
        if (this.mounted && e.target) {
            this.setState({
                [e.target.name]: e.target.checked
            });

            proxyRequest.manageOwnHealthcare = true;

            if (this.state.isShowManualAddress && e.target.name === 'healthrecord' && !e.target.checked)
                this.setState({ isShowManualAddress: false });
        }
    }

    onProxyAccessChange = (e) => {
        let { pharmacy, healthrecord, proxyRequest, isMinor } = this.state;
        proxyRequest.manageOwnHealthcare = e;
        //proxyRequest.isProxyAccessMapped = true;
        this.setState({ proxyRequest: { ...this.state.proxyRequest, ...proxyRequest } });
    }

    getProxyTermsAndConditions() {
        const { dateOfBirth, getProxyTermsAndConditionsAction, useTermsV2Endpoint, useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        const { pharmacy, healthrecord } = this.state;
        // Get featureId
        const proxySource = ProxyHelper.getProxySource(healthrecord, pharmacy);
        const age = getAge(dateOfBirth);
        const featureId = ProxyHelper.getFeatureId(REQUEST, proxySource, age, "");

        // Check if already called getProxyTermsAndConditions
        const fetchedProxyTermsAndConditions = useTermsV2Endpoint ? featureId !== null && getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response[0].featureId && getProxyTermsAndConditionsAction.response[0].featureId === featureId : featureId !== null && getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response.featureId && getProxyTermsAndConditionsAction.response.featureId === featureId;

        // if not called getProxyTermsAndConditions, call getProxyTermsAndConditions
        if (!fetchedProxyTermsAndConditions && featureId) {
            const logProxySource = ProxyHelper.getLogProxySource(proxySource);
            let count = listOfSelectedProxyUsers?.length > 0
            logUI(`MBHWeb.UI.ProxyRequest.${logProxySource}.GetProxyTermsAndConditions${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
            this.props.getProxyTermsAndConditions(featureId);
        }
    }

    acceptProxyTermsAndConditions() {
        const { userDetails, dateOfBirth, myChartId, getProxyTermsAndConditionsAction, useTermsV2Endpoint, useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        const { pharmacy, healthrecord } = this.state;
        const { userName, Email } = userDetails;
        const proxySource = ProxyHelper.getProxySource(healthrecord, pharmacy);
        const age = getAge(dateOfBirth);
        const featureId = ProxyHelper.getFeatureId(REQUEST, proxySource, age, "");
        const versionId = useTermsV2Endpoint ? getProxyTermsAndConditionsAction.response[0].versionId : getProxyTermsAndConditionsAction.response.versionId;
        const logProxySource = ProxyHelper.getLogProxySource(proxySource);
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyRequest.${logProxySource}.AcceptProxyTermsAndConditions${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        this.props.acceptProxyTermsAndConditions(featureId, true, userName, Email, myChartId, "", versionId); // Save proxy terms and conditions flag
    }

    onProxyRequestStepped = (success, proxyRequest) => {
        this.setState({ proxyRequest: { ...this.state.proxyRequest, ...proxyRequest } });
        const { healthrecord, pharmacy, isMinor } = this.state;
        /*const showTerms = pharmacy && !healthrecord && !isMinor ? false : true;
        if (showTerms) {*/
        this.getProxyTermsAndConditions();
        //}
    }

    fileInputChange = (base64Data, fileName, fileExtension) => {
        if (base64Data && fileName && fileExtension) {
            this.setState({
                proxyRequest: {
                    ...this.state.proxyRequest,
                    attachments: [{
                        base64Data,
                        fileExtension,
                        fileName
                    }],
                    documentSubmitted: false
                }
            });
        }
    }

    navigateToProxyManagment() {
        this.props.history.push("/proxymanagement");
    }

    navigateToManageNotifications() {
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        const { proxyRequest } = this.state;
        let activeUser = `${proxyRequest.firstName}${proxyRequest.lastName}`;
        let count = listOfSelectedProxyUsers?.length > 0
        this.props.history.push("/onboarding/managenotifications");
        logUI(`MBHWeb.UI.ProxyRequest.Failed.TryAgainLater${ProxyHelper.getProxyActiveUser(activeUser, count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
    }

    navigateToProxyRequestDOB() {
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        const { proxyRequest } = this.state;
        let activeUser = `${proxyRequest.firstName}${proxyRequest.lastName}`;
        let count = listOfSelectedProxyUsers?.length > 0
        {
            useOnboardingLayout ?
                (
                    this.props.history.push("/onboarding/proxyrequestDOB"),
                    logUI(`MBHWeb.UI.ProxyRequest.Failed.TryAgain${ProxyHelper.getProxyActiveUser(activeUser, count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath())
                )
                :
                this.props.history.push("/proxyrequestDOB");
        }

    }

    render() {
        const { proxyRequest, healthrecord, pharmacy, isMinor, isSubmitted, currentStep, isDcjEnrollment } = this.state;
        const { userPharmacy, requestRxErrorMessage, errorInfo, switchToPharmacy, myChartId, minorRelationships, majorRelationships,
            serverData, requestRxPending, requestEpicFailure, requestEpicPending, getProxyTermsAndConditionsAction,
            enableProxyRequestV2, requestEpicErrorMessage, errorEpicInfo, statusCode, useTermsV2Endpoint, useOnboardingLayout, listOfSelectedProxyUsers, hasSelectedProxySuggestionUsers } = this.props;
        //const requestEpicErrorMessage = requestEpicErrorMessage ? UNABLETOPROCESSMSG : "";
        const showDocUploadForMinor = isMinor && healthrecord && proxyRequest && proxyRequest.relationship && proxyRequest.relationship !== "Parent/Guardian of Child";
        let relationType = "";
        minorRelationships && minorRelationships.map(relation => {
            if (relation.label === proxyRequest.relationship)
                relationType = relation.label;
        });
        if (relationType === "Step-Parent")
            relationType = "step parent";
        else
            relationType = relationType.toLowerCase();
        const termsandconditions = useTermsV2Endpoint ? getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response[0].textToDisplay ? getProxyTermsAndConditionsAction.response[0].textToDisplay : "" : getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response.textToDisplay ? getProxyTermsAndConditionsAction.response.textToDisplay : "";
        const showUploadDocuments = enableProxyRequestV2 ? !isMinor && healthrecord && !proxyRequest.manageOwnHealthcare : !isMinor && healthrecord;
        const showManageAccountAccess = statusCode && (statusCode === 429 || statusCode === 409 || statusCode === "AccountAccessExists");
        return (
            <div className="container-fluid body-content new-proxy-request-container">
                <div className="row">
                    {!isSubmitted
                        ? <div className="col-12">
                            <div className="row">
                                <div className="col-12 progtrckr-divider" />
                                <div className="col-12 maxWidth-content">
                                    <div className={`step-progress no-page-heading ${showDocUploadForMinor || (!isMinor && healthrecord) ? "upload-doc-active" : ""}`}>
                                        <OurStepManager ref={this.stepManagerRef} baseURL={this.baseURL}
                                            backButtonCls='hidden' startingStep={this.state.startAtStep ? this.state.startAtStep : 0} onStepChange={this.onStepChange}
                                            showSteps={!(useOnboardingLayout && isMinor)}
                                        >
                                            {!useOnboardingLayout && <AccessType steptitle='Access Type'
                                                isMinor={isMinor} healthrecord={healthrecord}
                                                pharmacy={pharmacy} onAccessTypeChange={this.onAccessTypeChange}
                                                myChartId={myChartId} isDcjEnrollment={isDcjEnrollment}
                                                enableProxyRequestV2={enableProxyRequestV2}
                                                useOnboardingLayout={useOnboardingLayout}
                                                listOfSelectedProxyUsers={listOfSelectedProxyUsers}
                                            />}

                                            {!isMinor && healthrecord && enableProxyRequestV2 &&
                                                <ProxyAccess
                                                    steptitle="Patient Access"
                                                    shouldHideContinueButton
                                                    proxyRequestData={proxyRequest}
                                                    isMinor={isMinor}
                                                    healthrecord={healthrecord}
                                                    pharmacy={pharmacy}
                                                    onProxyAccessChange={this.onProxyAccessChange}
                                                    onGoNext={this.onProxyRequestStepped}
                                                    useOnboardingLayout={useOnboardingLayout}
                                                    listOfSelectedProxyUsers={listOfSelectedProxyUsers}
                                                />
                                            }

                                            {showUploadDocuments && !enableProxyRequestV2 &&
                                                <MajorUploadDocuments
                                                    steptitle='Upload Documents'
                                                    showInfo
                                                    title="We'll need documentation to verify your medical power of attorney status."
                                                    submitFileInputChange={this.fileInputChange}
                                                    proxyRequestData={proxyRequest}
                                                    healthrecord={healthrecord}
                                                    pharmacy={pharmacy}
                                                    onGoNext={this.onProxyRequestStepped}
                                                    validFileTypes={serverData.medicalRecordProxyFileTypes}
                                                    useOnboardingLayout={useOnboardingLayout}
                                                    listOfSelectedProxyUsers={listOfSelectedProxyUsers}
                                                />
                                            }

                                            <ProxyInfo
                                                steptitle={'Patient Info'}
                                                continueButtonText={"Continue"}
                                                dob={proxyRequest.dob}
                                                proxyRequestData={proxyRequest}
                                                onChange={this.onChange}
                                                healthrecord={healthrecord}
                                                pharmacy={pharmacy}
                                                isMinor={isMinor}
                                                onGoNext={this.onProxyRequestStepped}
                                                isShowManualAddress={this.state.isShowManualAddress}
                                                handleManualAddressState={this.handleManualAddressState}
                                                minorRelationOptions={minorRelationships}
                                                majorRelationOptions={majorRelationships}
                                                onSubmit={this.submitProxyRequest}
                                                enableProxyRequestV2={enableProxyRequestV2}
                                                useOnboardingLayout={useOnboardingLayout}
                                                listOfSelectedProxyUsers={listOfSelectedProxyUsers}
                                            />

                                            {showUploadDocuments && enableProxyRequestV2 &&
                                                <MajorUploadDocuments
                                                    steptitle='Upload Documents'
                                                    showInfo
                                                    title="We'll need documentation to verify your relationship to the patient."
                                                    submitFileInputChange={this.fileInputChange}
                                                    proxyRequestData={proxyRequest}
                                                    healthrecord={healthrecord}
                                                    pharmacy={pharmacy}
                                                    onGoNext={this.onProxyRequestStepped}
                                                    validFileTypes={serverData.medicalRecordProxyFileTypes}
                                                    useOnboardingLayout={useOnboardingLayout}
                                                    listOfSelectedProxyUsers={listOfSelectedProxyUsers}
                                                />
                                            }

                                            {showDocUploadForMinor &&
                                                <MajorUploadDocuments
                                                    steptitle='Upload Documents'
                                                    isMinor={isMinor}
                                                    showInfo
                                                    title={relationType === 'other' ? "Please upload documentation to verify guardianship." : `As this minor's ${relationType}, please upload documentation to verify guardianship.`}
                                                    proxyRequestData={proxyRequest}
                                                    submitFileInputChange={this.fileInputChange}
                                                    healthrecord={healthrecord}
                                                    pharmacy={pharmacy}
                                                    onGoNext={this.onProxyRequestStepped}
                                                    validFileTypes={serverData.medicalRecordProxyFileTypes}
                                                    useOnboardingLayout={useOnboardingLayout}
                                                    listOfSelectedProxyUsers={listOfSelectedProxyUsers}
                                                />
                                            }
                                            {/*pharmacy && !healthrecord && !isMinor ? null :*/
                                                <AcceptTerms
                                                    steptitle='Terms & Submit'
                                                    continueButtonText="Agree and Submit"
                                                    onSubmit={this.submitProxyRequest}
                                                    proxyRequestData={proxyRequest}
                                                    healthRecordSelected={healthrecord}
                                                    pharmacySelected={pharmacy}
                                                    onGoNext={this.onProxyRequestStepped}
                                                    termsandconditions={termsandconditions}
                                                    isWaitingForTermsInfo={getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.waiting}
                                                    useOnboardingLayout={useOnboardingLayout}
                                                    listOfSelectedProxyUsers={listOfSelectedProxyUsers}
                                                />
                                            }
                                        </OurStepManager>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : <div className="col-12">
                            <ProxyConfirmation
                                requestType={isMinor ? REQUEST : enableProxyRequestV2 ? REQUESTV2 : REQUEST}
                                grantAccessToSomeone={this.requestAnotherAccess}
                                handleSuccessContinue={this.handleSuccessContinue}
                                accessToAnotherAccountPath="/proxyrequestDOB"
                                proxyRequestData={proxyRequest}
                                requestRxErrorMessage={requestRxErrorMessage}
                                requestEpicErrorMessage={requestEpicErrorMessage}

                                requestRxPending={requestRxPending}
                                requestEpicPending={requestEpicPending}

                                healthRecordSelected={healthrecord}
                                pharmacySelected={pharmacy}

                                errorInfo={errorInfo || errorEpicInfo}
                                switchToPharmacy={switchToPharmacy}
                                userPharmacy={userPharmacy}
                                isMinor={isMinor}
                                retryFailedProxyRequest={this.retryProxyRequest}
                                enableProxyRequestV2={enableProxyRequestV2}

                                navigateToProxyRequestDOB={this.navigateToProxyRequestDOB}
                                hideRetry={showManageAccountAccess}
                                showManageAccountAccess={showManageAccountAccess}
                                navigateToManageAccount={this.navigateToProxyManagment}
                                navigateToManageNotifications={this.navigateToManageNotifications}
                                useOnboardingLayout={useOnboardingLayout}
                                isFromInHome={this.isFromInHome}
                            />
                        </div>
                    }
                </div>
                {!isSubmitted && !useOnboardingLayout &&
                    <ConfirmationModal when={this.dataEntered()} blockNavigation={this.blockNavigation.bind(this)} callbackOnLeave={this.callbackOnLeave} />
                }

            </div>);
    }
}

const mapStateToProps = (state) => {
    const requestData = state.common[types.PROXY_REQUEST_DATA];
    const dob = requestData && requestData.pData && requestData.pData.dateOfBirth ? requestData.pData.dateOfBirth : "";
    const requestRx = state.common[types.INITIATE_PROXY_RX_REQUEST];
    const requestEpic = state.common[types.INITIATE_PROXY_EPIC_REQUEST];
    const requestRxResponse = requestRx && requestRx.response;
    //Handle ExternalLoginId vs patientid depends on proxyInfo.
    const pharmacyUser = requestRxResponse && {
        firstName: requestRxResponse.FirstName, lastName: requestRxResponse.LastName,
        pharmacyPatientId: requestRxResponse.ExternalLoginId ? requestRxResponse.ExternalLoginId : requestRxResponse.PatientId ? requestRxResponse.PatientId : null
    };

    let errorMessageOnRx = null, errorInfoOnRx = null, errorMessageOnEpic = null, errorInfoOnEpic = null, statusCode = null;

    const getErrorMsg = (request, errorStatus) => {
        let errorMsg = null;
        let msg = null;
        let info = null;

        switch (errorStatus) {
            case 404:
                msg = "Sorry, we can’t find a matching account.";
                info = "Make sure the information matches this person’s records.";
                break;
            case 429:
            case "AccountAccessExists":
                errorMsg = splitErrorMsg(request.error);
                break;
            case 409:
                if (request.errorMessage)
                    errorMsg = splitErrorMsg(request.errorMessage);
                else
                    msg = REQUESTPENDINGMSG;
                break;
            default:
                if (request.errorMessage)
                    errorMsg = splitErrorMsg(request.errorMessage);
                else
                    errorMsg = splitErrorMsg(request.error);
                break;
        }

        if (errorMsg) {
            return errorMsg;
        } else {
            return { msg: msg, info: info };
        }
    }

    const splitErrorMsg = (error) => {
        const errorMessage = error.errorMessage && typeof error.errorMessage === "string"
            ? error.errorMessage
            : typeof error === "string"
                ? error
                : UNABLETOPROCESSMSG;

        const splitByMsg = errorMessage.split('. ');
        const msg = splitByMsg.length > 1 ? splitByMsg[0] + '.' : errorMessage;
        const info = splitByMsg[1] ? splitByMsg[1] : null;

        return { msg: msg, info: info };
    }

    // BSW Pharmacy Error
    if (requestRx && requestRx.error) {
        const errorRXStatus = requestRx.error.errorCode ? requestRx.error.errorCode : requestRx.error;
        const errorRXMsg = getErrorMsg(requestRx, errorRXStatus);

        errorMessageOnRx = errorRXMsg.msg;
        errorInfoOnRx = errorRXMsg.info;
        statusCode = requestRx.error.errorCode ? requestRx.error.errorCode : typeof requestRx.error === 'number' ? requestRx.error : null;
    }
    else {//this is incase api catch exception which cannot read statuscode.
        if (requestRx && typeof requestRx.error === "string") {
            errorMessageOnRx = UNABLETOPROCESSMSG;
            errorInfoOnRx = (typeof requestRx.error === "string") && requestRx.error;
        } else if (requestRx && typeof requestRx.success !== 'undefined' && requestRx.success === false) {
            errorMessageOnRx = UNABLETOPROCESSMSG;
        }
    }

    // Medical Record Error
    if (requestEpic && requestEpic.error) {
        const errorEpicStatus = requestEpic.error.errorCode ? requestEpic.error.errorCode : requestEpic.error.status;
        const errorEpicMsg = getErrorMsg(requestEpic, errorEpicStatus);

        errorMessageOnEpic = errorEpicMsg.msg;
        errorInfoOnEpic = errorEpicMsg.info;
        statusCode = requestEpic.error.errorCode ? requestEpic.error.errorCode : typeof requestEpic.error.status === 'number' ? requestEpic.error.status : null;

        if (statusCode === null) {
            switch (errorMessageOnEpic) {
                case "This proxy relationship already exists.":
                    statusCode = "AccountAccessExists";
                    break;
                default:
                    break;
            }
        }
    }
    else {//this is incase api catch exception which cannot read statuscode.
        if (requestEpic && typeof requestEpic.error === "string") {
            errorMessageOnEpic = UNABLETOPROCESSMSG;
            errorInfoOnEpic = (typeof requestEpic.error === "string") && requestEpic.error;
        } else if (requestEpic && typeof requestEpic.success !== 'undefined' && requestEpic.success === false) {
            errorMessageOnEpic = UNABLETOPROCESSMSG;
        }
    }
    const proxyRelationShipTypes = state.common[types.PROXY_RELATIONSHIP_TYPES];

    return {
        getProxyTermsAndConditionsAction: state.common[types.PROXY_TERMS_AND_CONDITIONS],
        acceptProxyTermsAndConditionsAction: state.common[types.ACCEPT_PROXY_TERMS_AND_CONDITIONS],
        requestRxErrorMessage: errorMessageOnRx,
        errorInfo: errorInfoOnRx,
        requestEpicErrorMessage: errorMessageOnEpic,
        errorEpicInfo: errorInfoOnEpic,
        userDetails: state.sso.userDetails,
        myChartId: state.domain.mc,
        dateOfBirth: dob,
        proxyRelationTypesPending: state.common.proxyRelationTypesPending,
        requestRxPending: requestRx && requestRx.waiting,
        requestEpicPending: requestEpic && requestEpic.waiting,
        requestEpicFailure: requestEpic && requestEpic.error,
        minorRelationships: proxyRelationShipTypes && proxyRelationShipTypes.response && proxyRelationShipTypes.response["Minor"] ? proxyRelationShipTypes.response["Minor"] : [],
        majorRelationships: proxyRelationShipTypes && proxyRelationShipTypes.response && proxyRelationShipTypes.response["Adult"] ? proxyRelationShipTypes.response["Adult"] : [],
        serverData: state.session.serverData,
        userPharmacy: pharmacyUser,
        enableProxyRequestV2: state.session.serverData ? state.session.serverData.enableProxyRequestV2 : false,
        statusCode,
        useTermsV2Endpoint: state.session.serverData ? state.session.serverData.useTermsV2Endpoint : false,
        useOnboardingLayout: state.session.useOnboardingLayout,
        listOfSelectedProxyUsers: state.session.selectedProxySuggestionUsers,
        hasSelectedProxySuggestionUsers: state.session.hasSelectedProxySuggestionUsers,
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false
    };
};


const mapDispatchToProps = (dispatch) => ({
    switchToPharmacy: (pharmacyUser) => dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser }),
    initializeRequestData: () => {
        dispatch({ type: types.PROXY_REQUEST_DATA, pData: {} });
    },
    getProxyRelationshipTypes: () => dispatch({ type: types.PROXY_RELATIONSHIP_TYPES }),
    requestRxAccess: (attachments, proxySource, receiver, requester, requestType) =>
        dispatch({
            type: types.INITIATE_PROXY_RX_REQUEST, data: {
                attachments, proxySource, receiver, requester, requestType
            }
        }),
    requestEpicAccess: (attachments, proxySource, receiver, requester, requestType) =>
        dispatch({
            type: types.INITIATE_PROXY_EPIC_REQUEST, data: {
                attachments, proxySource, receiver, requester, requestType
            }
        }),
    getProxyTermsAndConditions: (featureId, callback) =>
        dispatch({ type: types.PROXY_TERMS_AND_CONDITIONS, data: { featureId }, callback }),

    acceptProxyTermsAndConditions: (featureId, isAccepted, userName, email, loginId, proxyId, versionId, callback) =>
        dispatch({ type: types.ACCEPT_PROXY_TERMS_AND_CONDITIONS, data: { featureId, isAccepted, userName, email, loginId, proxyId, versionId }, callback })
});

export default connect(mapStateToProps, mapDispatchToProps)(ProxyRequest);